import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface Props {
  onClick: () => void;
}

export default function BackButton({ onClick }: Props) {
  return (
    <IconButton onClick={onClick} aria-label="Voltar" sx={{ width: 48, height: 48, backgroundColor: 'neutrals.beige3' }}>
      <ArrowBackIcon />
    </IconButton>
  );
}
